import { ActivityTypeEnum } from '@authority-labs/enums';
import { BaseDto } from './base.dto';

export class ActivityLog {
  createdAt?: Date;
  entityId?: number;
  requestId?: string;
  entity?: string;
  username?: string;
  oldValue?: BaseDto;
  newValue?: BaseDto;
  modifiedFields?: string[];
  activityType?: ActivityTypeEnum;
}
